module.exports = __webpack_public_path__ + "static/media/sonicstop-5.aa629677.jpg";